/**
 * Send merch receipt via Cheppar PHP (deployed at /cheppar/sendWhatsAppReceipt.php).
 */

export function getReceiptUrl() {
    if (process.env.REACT_APP_WHATSAPP_RECEIPT_URL) {
        return process.env.REACT_APP_WHATSAPP_RECEIPT_URL;
    }
    if (typeof window !== "undefined" && window.location?.origin) {
        return `${window.location.origin}/cheppar/sendWhatsAppReceipt.php`;
    }
    return "https://cheppar.co.ke/cheppar/sendWhatsAppReceipt.php";
}

function normalizePhone(raw) {
    const digits = String(raw || "").replace(/\D/g, "");
    if (digits.startsWith("0") && digits.length === 10) {
        return `254${digits.slice(1)}`;
    }
    if (digits.startsWith("254")) return digits;
    return `254${digits.replace(/^0+/, "")}`;
}

/** POST order to sendWhatsAppReceipt.php */
export async function sendMerchWhatsAppReceipt(order) {
    const url = getReceiptUrl();
    const to = normalizePhone(order.whatsapp || order.phone);

    const cupTeams = Array.isArray(order.cup_teams)
        ? order.cup_teams
        : typeof order.cup_teams === "string"
          ? JSON.parse(order.cup_teams)
          : [];

    const payload = {
        to,
        order: {
            id: order.id,
            customer_name: order.customer_name,
            whatsapp: to,
            color: order.color,
            packs: order.packs,
            cups: order.cups,
            cup_teams: cupTeams,
            total_kes: order.total_kes,
            mpesa_receipt: order.mpesa_receipt || order.mpesacode || null,
            external_reference: order.external_reference,
        },
    };

    let response;
    try {
        response = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
    } catch (networkErr) {
        throw new Error(
            `Could not reach receipt script at ${url}. Is sendWhatsAppReceipt.php uploaded?`
        );
    }

    const text = await response.text();
    let data = {};
    try {
        data = text ? JSON.parse(text) : {};
    } catch {
        throw new Error(
            text?.slice(0, 200) ||
                `Receipt script returned non-JSON (${response.status})`
        );
    }

    if (!response.ok || data.ok === false) {
        throw new Error(
            data.error ||
                `Receipt failed (${response.status}). Check /cheppar/ultramsg.config.php on server.`
        );
    }

    return data;
}
